<div class="shell-root flex h-screen w-screen overflow-hidden
            bg-gradient-to-br from-slate-100 via-[#F5F3EE] to-amber-50/50
            dark:from-slate-950 dark:via-slate-900 dark:to-slate-950
            text-gray-900 dark:text-gray-100">

  <!-- Left Sidebar (Desktop) — inset charcoal rail -->
  <aside class="hidden xl:flex w-auto shrink-0 h-full pl-3 py-3 pr-0 overflow-visible
                animation-slide-right" *ngIf="!disableHeader">
    <div class="shell-sidebar-rail h-full overflow-hidden rounded-[1.75rem]
                bg-[#3a3a3a] dark:bg-[#2a2a2a]
                border border-[#2d2d30]/80 dark:border-slate-800/80
                shadow-[0_12px_40px_-12px_rgba(0,0,0,0.45)]">
      <app-sidebar variant="desktop"></app-sidebar>
    </div>
  </aside>

  <!-- Left Sidebar Overlay (Mobile) -->
  <div *ngIf="showSidebar() && !disableHeader" class="fixed inset-0 z-40 xl:hidden">
    <div class="absolute inset-0 bg-slate-900/40 backdrop-blur-sm transition-opacity" (click)="toggleSidebar()">
    </div>
    <div class="absolute top-0 left-0 h-full p-3">
      <div class="h-full overflow-hidden rounded-[1.75rem]
                  bg-[#3a3a3a] border border-[#2d2d30]/80 shadow-2xl">
        <app-sidebar variant="drawer" (navigated)="closeSidebar()" (closeRequested)="closeSidebar()"></app-sidebar>
      </div>
    </div>
  </div>

  <!-- Right Section: Header and Main Content -->
  <div class="flex-1 flex flex-col overflow-hidden relative min-w-0">

    <!-- Header (floating glass bar) -->
    <app-header (toggleSidebar)="toggleSidebar()" class="flex-none z-30 px-3 pt-3 pb-1 md:px-4 md:pt-3">
    </app-header>

    <!-- Main Content -->
    <main class="flex-1 overflow-y-auto scroll-smooth">
      <router-outlet></router-outlet>
    </main>

  </div>

</div>

<app-menu-command-palette *ngIf="!disableHeader"></app-menu-command-palette>
